/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy API
 * API for Pharmacy
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PharmacyCounselingSlotQuotaTypename = "PharmacyCounselingSlotQuota" as const;

/**
 *
 * @export
 * @interface PharmacyCounselingSlotQuota
 */
export interface PharmacyCounselingSlotQuota {
  /**
   *
   * @type {string}
   * @memberof PharmacyCounselingSlotQuota
   */
  date: string;
  /**
   *
   * @type {number}
   * @memberof PharmacyCounselingSlotQuota
   */
  id?: number;
  /**
   *
   * @type {number}
   * @memberof PharmacyCounselingSlotQuota
   */
  pharmacyId?: number;
  /**
   *
   * @type {number}
   * @memberof PharmacyCounselingSlotQuota
   */
  quota: number;
  /**
   * Resource type name
   * @type {string}
   * @memberof PharmacyCounselingSlotQuota
   */
  readonly __typename?: string;
}

export function PharmacyCounselingSlotQuotaFromJSON(json: any): PharmacyCounselingSlotQuota {
  return PharmacyCounselingSlotQuotaFromJSONTyped(json, false);
}

export function PharmacyCounselingSlotQuotaFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PharmacyCounselingSlotQuota {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PharmacyCounselingSlotQuotaTypename,

    date: json["date"],
    id: !exists(json, "id") ? undefined : json["id"],
    pharmacyId: !exists(json, "pharmacy_id") ? undefined : json["pharmacy_id"],
    quota: json["quota"],
  };
}

export function PharmacyCounselingSlotQuotaToJSON(object?: PharmacyCounselingSlotQuota | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    date: value.date,
    id: value.id,
    pharmacy_id: value.pharmacyId,
    quota: value.quota,
  };
}
